import Icon, { IconProps } from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';

import { BitkitIconTypes } from '../types';

type Glyph = Required<IconProps>['glyph'];
type ArgumentsOf<F extends Function> = F extends (...args: infer A) => any
  ? A
  : never;

const glyph = (props: ArgumentsOf<Glyph>[0]) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8219 8.74072C11.7094 8.74072 9.26565 11.1217 8.33752 12.3091C8.95627 13.4996 11.7094 15.8774 14.8219 15.8774C17.9344 15.8774 20.6875 13.4965 21.3063 12.3091C20.3813 11.1186 17.9344 8.74072 14.8219 8.74072ZM14.8219 9.7251C16.2719 9.7251 17.4469 10.8817 17.4469 12.3091C17.4469 13.7364 16.2719 14.8931 14.8219 14.8931C13.3719 14.8931 12.1969 13.7364 12.1969 12.3091C12.1969 10.8817 13.3719 9.7251 14.8219 9.7251Z"
      fill={token('color.icon')}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6406 12.3151L16.5187 14.5638L14.8687 17.3816L11.9469 16.9017L10.9125 19.6303H7.60937L6.56875 16.9017L3.64688 17.3816L2 14.5638L3.875 12.3151L2 10.0665L3.64688 7.24868L6.56875 7.72549L7.60937 5H10.9125L11.9469 7.72549L14.8687 7.24868L16.5219 10.0665L14.6406 12.3151Z"
      fill={token('color.icon')}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8219 14.8961C13.3719 14.8961 12.1969 13.7364 12.1969 12.3091C12.1969 10.8817 13.3719 9.7251 14.8219 9.7251C15.4063 9.7251 15.9469 9.91274 16.3844 10.2327L16.5219 10.0666L15.7907 8.81763C15.4782 8.76841 15.1532 8.74072 14.8219 8.74072C11.7094 8.74072 9.2657 11.1186 8.3407 12.3091C8.95632 13.4996 11.7094 15.8774 14.8219 15.8774C15.1501 15.8774 15.4751 15.8498 15.7938 15.8005L16.5188 14.5639L16.3782 14.3947C15.9407 14.7085 15.4032 14.8961 14.8219 14.8961Z"
      fill={token('elevation.surface.raised')}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6406 12.3152L16.3781 14.3947C15.9406 14.7085 15.4031 14.8961 14.8219 14.8961C13.3719 14.8961 12.1969 13.7364 12.1969 12.3091C12.1969 10.8817 13.3719 9.7251 14.8219 9.7251C15.4063 9.7251 15.9469 9.91274 16.3844 10.2327L14.6406 12.3152Z"
      fill={token('color.icon')}
    />
  </svg>
);

export const CodeReviewerIcon = (props: BitkitIconTypes): JSX.Element => (
  <Icon {...props} glyph={glyph} />
);
